import * as types from './mutations';

const state = {
    isTouch: false,
    device: '',
    sidebarVisibilityOnMobile: false
};

const getters = {
    getDevice(state) {
        return state.device;
    },
};

const actions = {

};

const mutations = {
    [types.SET_TOUCH_STATE](state, isTouch) {
        state.isTouch = isTouch;
    },

    [types.SET_DEVICE](state, device) {
        state.device = device;
    },


    [types.TOGGLE_SIDEBAR_VISIBILITY_ON_MOBILE](state, visibility = undefined) {
        state.sidebarVisibilityOnMobile = visibility || ! state.sidebarVisibilityOnMobile;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};